module.exports = __webpack_public_path__ + "img/patient.1bc6d269.png";